import { TimePicker } from 'antd';
import dayjs from 'dayjs';
import React from 'react';

function AntdTimePicker({
    label,
    name,
    className,
    required,
    value,
    disabled,
    onChange,
    readOnly,
    uppercase,
    description,
    hourStep,
    minuteStep,
    needConfirm,
    error,
    format,
    showTime
  }) {
  return (
    <div className={`${className ?? ''} inputBox w-full text-xs tracking-tight space-y-1`}>
      {!readOnly && (
        <TimePicker
          use12Hours={showTime}
          showTime={showTime}
          format={format ?? 'MMM DD, YYYY'}
          id={name}
          hourStep={hourStep}
          minuteStep={minuteStep}
          disabled={disabled}
          allowClear={!readOnly}
          needConfirm={needConfirm ?? false}
          className={`${uppercase ? 'uppercase' : ''} inputField disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed placeholder-gray-400 text-gray-900 text-base rounded-md p-3 w-full appearance-none focus:ring-1 focus:ring-accent border ${error ? 'border-red-500' : 'border-gray-200'} focus:border-accent outline-none focus:outline-none transition ease-in-out duration-500`}
          value={value ? dayjs(value) : null}
          onChange={onChange}
        />
      )}
      {readOnly && (
        <p className={`${uppercase ? 'uppercase' : ''} inputField text-md my-2`}>{value ? dayjs(value).format(format ?? 'MMM DD, YYYY') : ''}</p>
      )}
      <span className={`${uppercase ? 'uppercase' : ''} inputLabel inputLabel-raised text-sm`}>{label}{required && <span className="text-red-500 ml-1">*</span>}</span>
      {description && <div className="text-xs ml-2 font-light text-gray-500">{description}</div>}
      {error && <div className="text-sm ml-2 font-light text-red-500">{error}</div>}
    </div>
  );
}

export default AntdTimePicker
